import AdminLoginApi from './AdminLoginApi';
import UserLoginApi from './UserLoginApi';

export default {
  admin: AdminLoginApi,
  user: UserLoginApi,
};
